// @flow
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { cookieSet, cookiesLoaded } from './actions';
import { LOAD_COOKIES, SET_COOKIE } from './constants';

import Cookie from '<drivers>/cookie';
import { getUserId } from '~/core/state/user/selectors';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import type { SetCookieAction } from './types';
import toResult from '../toResult';

function* loadCookies(): Generator<Effect, *, *> {
    const [cookies, error] = yield call(toResult(Cookie.load));
    yield put(cookiesLoaded(error || cookies));
}

function* watchLoadCookies(): Generator<Effect, *, *> {
    yield takeEvery(LOAD_COOKIES, handleSaga(loadCookies));
}

function* setCookie({ payload: { key, value } }: SetCookieAction) {
    const userId = yield select(getUserId);
    const userKey = `${userId}-${key}`;
    const [, error] = yield call(Cookie.set, userKey, value);
    yield put(cookieSet(error || { key: userKey, value }));
}

function* watchSetCookie(): Generator<Effect, *, *> {
    yield takeEvery(SET_COOKIE, handleSaga(setCookie));
}

export default [watchLoadCookies, watchSetCookie];



// WEBPACK FOOTER //
// ./src/core/state/cookies/sagas.js